import { Container } from '@cleartrip/ct-design-components'
import React from 'react'

const FareCardBadge = ({ text = 'BEST VALUE', badgeBackground = '#11A670' }) => {
    return (
        <Container
            className="p-absolute flex px-1 br-4 ml-4"
            style={{
                top: '-11px',
                paddingTop: '2px',
                paddingBottom: '2px',
                backgroundColor: badgeBackground,
                width: 'fit-content',
                // Above the fare-card shell — otherwise the card's opaque top
                // border/background clips the bottom half of this pill.
                zIndex: 5,
            }}
        >
            <Container
                className="fw-600 lh-16 c-neutral-100"
                style={{
                    fontSize: '9px',
                    textTransform: 'uppercase'
                }}
            >
                {text}
            </Container>
        </Container>
    )
}

export default FareCardBadge
